const locations = document.querySelectorAll('.c-locations__list--item:not(.blank)')
const blanks = document.querySelectorAll('.c-locations__list--item.blank')
const categories = document.querySelectorAll('[data-filter-locations]')

for (let i = 0; i < categories.length; i++) {
  const el = categories[i];
  handleEvent('click', {
    el: el,
    callback: () => {
      var prev_active = document.querySelector('.is-active[data-filter-locations]')
      if(prev_active) {
        prev_active.classList.remove('is-active')
      }

      el.classList.add('is-active')

      let visible_amount = 0;
      for (let i = 0; i < locations.length; i++) {
        if(locations[i].dataset.filterLocationsItem == el.dataset.filterLocations && el.dataset.filterLocations != '') {
          locations[i].style.display = 'block'
          visible_amount = visible_amount + 1;
        } else {
          locations[i].style.display = 'none'
        }
      }

      handleBlanks(visible_amount)
    }
  })
}

handleBlanks(locations.length);

function handleBlanks(val) {
  let blanks_amount;

  console.log(val);

  switch (val) {
    case 0:
    case 4:
    case 8:
      blanks_amount = 0
      break;
    case 1:
    case 5:
      blanks_amount = 3
      break;
    case 2:
    case 6:
      blanks_amount = 2
      break;
  }

  for (let i = 0; i < blanks.length; i++) {
    const el = blanks[i];
    if(i >= blanks_amount) {
      el.style.display = 'none'
    } else {
      el.style.display = 'block'
    }
  }
}
